import React, { memo, useState, useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';
import PaymentService from '../../services/payment';
import { PRODUCT_KEYS } from '../../services/subscription';

// NB: Remove Ads is intentionally absent — the £3.99 IAP was dropped from ASC
// (stuck READY_TO_SUBMIT) and the ad service never shows real ads, so the
// product would sell nothing. Consumable packs only.
const PURCHASE_OPTIONS = [
  {
    category: 'Undo Packs',
    items: [
      { id: PRODUCT_KEYS.UNDOS_10, name: '10 Undos', price: '£0.99' },
      { id: PRODUCT_KEYS.UNDOS_25, name: '25 Undos', price: '£1.99', badge: 'Popular' },
    ],
  },
  {
    category: 'Bomb Packs',
    items: [
      { id: PRODUCT_KEYS.BOMBS_10, name: '10 Bombs', price: '£0.99' },
      { id: PRODUCT_KEYS.BOMBS_25, name: '25 Bombs', price: '£1.99', badge: 'Popular' },
    ],
  },
];

function PurchaseModal({ onDismiss, onPurchased, initialCategory }) {
  const [visible, setVisible] = useState(false);
  const [purchasing, setPurchasing] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  const handlePurchase = useCallback(async (item) => {
    setPurchasing(item.id);
    try {
      const result = await PaymentService.purchase(item.id);
      if (result?.success) {
        // Native (StoreKit) purchases resolve in place — credit immediately.
        onPurchased?.();
      } else if (!result?.canceled) {
        toast.error(result?.error || 'Purchase failed');
      }
    } finally {
      setPurchasing(null);
    }
  }, [onPurchased]);

  return (
    <div className={`game-over-overlay${visible ? ' game-over-visible' : ''}`} role="dialog" aria-label="Purchase">
      <div className="purchase-modal-card">
        <div className="purchase-modal-header">
          <h3 className="purchase-modal-title">SHOP</h3>
          <button className="purchase-modal-close" onClick={onDismiss} aria-label="Close">
            &#10005;
          </button>
        </div>

        <div className="purchase-modal-content">
          {PURCHASE_OPTIONS.map((category) => (
            <div key={category.category} className="purchase-category">
              <h4 className="purchase-category-title">{category.category}</h4>
              {category.items.map((item) => (
                <div key={item.id} className="purchase-item">
                  <div className="purchase-item-info">
                    <span className="purchase-item-name">
                      {item.name}
                      {item.badge && <span className="purchase-item-badge">{item.badge}</span>}
                    </span>
                    {item.desc && <span className="purchase-item-desc">{item.desc}</span>}
                  </div>
                  <button
                    className="purchase-item-btn"
                    onClick={() => handlePurchase(item)}
                    disabled={purchasing === item.id}
                  >
                    {purchasing === item.id ? '...' : item.price}
                  </button>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(PurchaseModal);
